import LogoMoongy from "../../layout/logos/logo_moongy.svg";
import LogoDecode from "../../layout/logos/logo_decode.svg";
import LogoAdentis from "../../layout/logos/logo_adentis.svg";
import LogoAgap from "../../layout/logos/logo_Agap2IT.svg";
import LogoAgapNL from "../../layout/logos/agap2NL.png";
import LogoBee from "../../layout/logos/logo_bee_new.svg";
import LogoKCS from "../../layout/logos/logo_kcsit.svg";
import LogoTeamIT from "../../layout/logos/logo_teamit.svg";
import LogoSowin from "../../layout/logos/logo_sowin.svg";
import LogoRecodme from "../../layout/logos/logo_recodeme.png";
import LogoCodewin from "../../layout/logos/logo_Codewin.svg";
import LogoGMS from "../../layout/logos/logo_GMS.svg";
import LogoAts4it from "../../layout/logos/logo_ats4it.svg";
import LogoAgap2Ind from "../../layout/logos/logo_agap2IND.svg";

const CompanyLogo = ({ company, height, width, alt }) => {
  const companyNameToSource = (companyName) => {
    switch (companyName) {
      case "AGAP2":
        return LogoAgap;
      case "AGAP2NL":
        return LogoAgapNL;
      case "Decode":
        return LogoDecode;
      case "KCS":
        return LogoKCS;
      case "Adentis":
        return LogoAdentis;
      case "Bee":
        return LogoBee;
      case "TeamIT":
        return LogoTeamIT;
      case "Sowin":
        return LogoSowin;
      case "RECODME":
        return LogoRecodme;
      case "Codewin":
        return LogoCodewin;
      case "GMS":
        return LogoGMS;
      case "ATS4IT":
        return LogoAts4it;
      case "AGAP2IND":
        return LogoAgap2Ind;
      default:
        return LogoMoongy;
    }
  };

  return (
    <>
      <img
        src={companyNameToSource(company)}
        height={
          company === "RECODME" || company === "Codewim" || company === "AGAP2IND"
            ? (height = "85px")
            : height
        }
        width={width}
        alt={alt}
      />
    </>
  );
};

export default CompanyLogo;
